import { Box, Typography } from "@mui/material";
import { formatWeightWithUnits } from "../../../utils";

const BatchProductList = ({ products, globalData }) => {
  return (
    <Box sx={{ border: 1, borderColor: "divider" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          backgroundColor: "#E6EEF7",
          padding: "6px 10px",
          height: "34px",
          alignItems: "center",
        }}
      >
        <Typography
          fontWeight={600}
          fontSize={"12px"}
          sx={{ textAlign: "right" }}
        >
          Quantity
        </Typography>
      </Box>

      {/* Product List */}
      {products.map((product, index) => {
        const lastItem = products.length - 1;
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 12px",
              border: lastItem !== index ? 1 : 0,
              borderColor: "divider",
            }}
          >
            <Typography fontWeight={400} fontSize="14px" minWidth="150px">
              {product?.product_name}
            </Typography>
            <Typography
              fontWeight={600}
              color="#485364"
              lineHeight="16.94px"
              fontSize="14px"
              whiteSpace="nowrap"
            >
              {formatWeightWithUnits(
                product?.quantity,
                product?.unit,
                globalData?.all_Units
              )}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default BatchProductList;
